import React, { useState, useRef, useEffect } from "react";
import "./verification.css"; // Add your own CSS file for styling
import ActionButton from "../../general/ActionButton";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as theme from "../../theme";
import {
  getJWT,
  getProvinces,
  getTwoFAVerificationFailedMessage,
  getTwoFactorVerified,
  getUserRoles,
  resendCodeVerification,
  resendVerificationMessage,
  twoFAVerification,
  verifyToken,
} from "../../store/broker";
import { toast } from "react-toastify";

const VerificationScreen = () => {
  const dispatch = useDispatch();
  const history = useNavigate();

  const jwt = useSelector(getJWT);
  const verifiyMessage = useSelector(getTwoFactorVerified);
  const resendSuccessMessage = useSelector(resendVerificationMessage);
  const twoFAVerificationErrorMessage = useSelector(
    getTwoFAVerificationFailedMessage
  );
  const [code, setCode] = useState(["", "", "", "", "", ""]);
  const codeInputs = useRef([]);

  useEffect(() => {
    toast.error(twoFAVerificationErrorMessage);
  }, [twoFAVerificationErrorMessage]);

  const handleCodePaste = (event) => {
    const pastedCode = event.clipboardData.getData("text").toUpperCase();
    const newCode = pastedCode
      .slice(0, 6)
      .split("")
      .map((character) => character.toUpperCase());
    setCode(newCode);
  };

  const handleCodeChange = (index, event) => {
    const { value } = event.target;
    setCode((prevCode) => {
      const newCode = [...prevCode];
      newCode[index] = value;
      return newCode;
    });

    if (value !== "") {
      if (index < codeInputs.current.length - 1) {
        codeInputs.current[index + 1].focus();
      }
    } else {
      if (index > 0) {
        codeInputs.current[index - 1].focus();
      }
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Submit the verification code (add your own logic here)
    try {
      dispatch(
        twoFAVerification({
          code: code.join("").toUpperCase(),
        })
      ).then(() => {
        history("/");
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleResendCode = () => {
    // Handle resend code action (add your own logic here)
    setCode(["", "", "", "", "", ""]); // Reset the code to empty
    dispatch(resendCodeVerification())
      .then(() => {
        if (resendSuccessMessage) {
          toast.success(resendSuccessMessage);
        }
      })
      .catch(() => {});
    //Resend API Calling
  };

  return (
    <>
      <div
        style={{
          fontFamily: "GibsonSemiBd",
          fontSize: "1.6vw",
          color: theme.COLORS.primary_navyblue,
          textAlign: "center",
          position: "relative",
          top: "180px",
        }}
      >
        An authentication code has been sent to your corporate email address.{" "}
        <br />
        Please enter the code from this email.
      </div>

      <div
        className="verification-screen"
        style={{
          textAlign: "center",
          position: "relative",
          top: "233px",
        }}
      >
        <h2 className="h2">Two-Factor Authentication</h2>
        <form className="form" onSubmit={handleSubmit}>
          <div className="code-input-container">
            {code.map((digit, index) => (
              <input
                key={index}
                type="text"
                value={digit.toUpperCase()}
                onChange={(event) => handleCodeChange(index, event)}
                onPaste={handleCodePaste}
                ref={(input) => (codeInputs.current[index] = input)}
                maxLength={1}
              />
            ))}
          </div>
          <button type="submit" disabled={code.includes("")}>
            Verify
          </button>
        </form>
        <div className="resend-link" onClick={handleResendCode}>
          Resend Code
        </div>
      </div>
    </>
  );
};

export default VerificationScreen;
